
import { Component, Vue, Watch, Prop, } from 'vue-property-decorator'
import InputComponent from '@/components/InputHackmetrix/Index.vue'

@Component({
  components: {
    InputComponent,
  },
})
export default class CreateComponent extends Vue {
  @Prop({ required: true, }) readonly showDialog!: string
  @Prop({ required: true, }) readonly title!: string
  @Prop({ required: true, }) readonly title_button!: string
  @Prop({ required: true, }) readonly input_title!: string
  @Prop({ required: true, }) readonly input_placeholder!: string
  @Prop({ required: true, }) readonly input_title_2!: string
  @Prop({ required: true, }) readonly input_placeholder_2!: string
  @Prop({ required: true, }) readonly input_title_3!: string
  @Prop({ required: true, }) readonly input_placeholder_3!: string

  private dialog = false

  @Watch('showDialog')
  show (val: boolean): void {
    if (val) {
      this.dialog = true
    }
  }

  @Watch('dialog')
  dialogClose (): void {
    if (this.dialog === false) {
      this.$emit('close')
    }
  }

  private emitEvent () {
    this.dialog = false
    this.$emit('action')
  }
}
